import { QUIET_ZONE, code128Widths, isCode128B } from 'shared/lib/barcode'

/**
 * A Code 128 barcode drawn as SVG bars — what a label prints so a scanner reads
 * the code back (ticket 33). The bars are black on white whatever the theme, and
 * crisp at any size (`shape-rendering: crispEdges`). Text set B cannot write is
 * not drawn: the caller prints the code as text beside it anyway.
 */
export function Barcode({
	value,
	height = 56,
	className,
}: {
	value: string
	/** The bars' height in SVG units; the width follows the code's length. */
	height?: number
	className?: string
}) {
	if (!isCode128B(value)) return null
	const widths = code128Widths(value)
	const total = widths.reduce((a, b) => a + b, 0) + 2 * QUIET_ZONE
	let x = QUIET_ZONE
	const bars: { x: number; w: number }[] = []
	widths.forEach((w, i) => {
		if (i % 2 === 0) bars.push({ x, w })
		x += w
	})
	return (
		<svg
			className={className}
			viewBox={`0 0 ${total} ${height}`}
			preserveAspectRatio='none'
			shapeRendering='crispEdges'
			role='img'
			aria-label={value}
			data-testid='barcode'
			data-value={value}
		>
			<rect x={0} y={0} width={total} height={height} fill='#fff' />
			{bars.map((b) => (
				<rect key={b.x} x={b.x} y={0} width={b.w} height={height} fill='#000' />
			))}
		</svg>
	)
}
